import React from 'react';
import clsx from 'clsx';
import { Checkbox, Radio } from 'semantic-ui-react';
import { useIntl } from 'react-intl';

const OnOffNoLabel = ({
  checked,
  label,
  className,
  disabled,
  toggle,
  onClick,
  message,
  single,
}) => {
  const intl = useIntl();
  return (
    <>
      {!single && (
        <Checkbox
          disabled={disabled}
          toggle={toggle}
          checked={checked}
          label={intl.formatMessage({ id: message }, { label })}
          className={clsx('aridhia-on-off-no-label toggle-no-label', className)}
          onClick={disabled ? undefined : onClick}
        />
      )}
      {single && (
        <Radio
          disabled={disabled}
          checked={checked}
          label={intl.formatMessage({ id: message }, { label })}
          className={clsx('aridhia-on-off-no-label-single toggle-no-label', className)}
          onClick={disabled ? undefined : onClick}
        />
      )}
    </>
  );
};

export default OnOffNoLabel;
